import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion'; 
import { useContent } from './ContentContext';

const Home = () => {
  const [videoUrl, setVideoUrl] = useState(null);
  const [showNotifications, setShowNotifications] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const imageRef = useRef(null);

  // Auto-load video when component mounts
  useEffect(() => {
    setVideoUrl("https://res.cloudinary.com/dwfdzdaxk/image/upload/v1757189481/banner_images/Register_as_a_farmer_1_p3nqem.jpg");
  }, []);

  // Handle image load
  useEffect(() => {
    if (imageRef.current && imageRef.current.complete) {
      setImageLoaded(true);
    }
  }, []);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  
  const toggleNotifications = () => {
    setShowNotifications(!showNotifications);
  };
  
  const { publishedContent, isLoading } = useContent();
  
  return (
    <div className=''>
      <div className='px-4 md:pr-20 md:pl-[120px] relative'>
        <div className="flex justify-between items-center md:mb-2 mb-2 mt-2">
        <h1 className="text-[8px] md:text-[40px] text-[#FDBD26] font-bold whitespace-nowrap">
  Agricultural Technology
</h1>

          <div className="relative md:w-[700px] md:flex hidden w-[200px] ">
              <input
                type="text"
                placeholder="Search for service provider by category"
                className="w-full h-[20px] md:h-[50px] placeholder-white bg-[#142B24] rounded-[5px] md:rounded-[10px] border border-white 
                          text-white text-[4px] md:text-[16px] font-normal pr-10 transition-all duration-300 ease-in-out"
              />
              <img
                src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1754578085/Search_light_lodmiu.png"
                alt="Search Icon"
                className="absolute right-5 top-[60%] md:top-1/2 transform -translate-y-1/2 w-[10px] h-[10px] md:w-[43px] md:h-[43px] cursor-pointer"
              />
            </div>
        </div>

        {/* Video/Image display */}
        <div className="md:">
          <div className="relative rounded-[5px] overflow-hidden h-full w-full">
            {isLoading ? (
              <div className="w-full h-full bg-gray-200 flex items-center justify-center">
                <div className="absolute inset-0 bg-gray-300 animate-pulse"></div>
                <div className="relative z-10">
                  <div className="w-10 h-10 border-4 border-[#FDBD26] border-t-transparent rounded-full animate-spin"></div>
                </div>
              </div>
            ) : publishedContent.isVideo ? (
              <>
                <video
                  src={publishedContent.video}
                  controls
                  autoPlay
                  muted
                  className="w-full h-full object-cover cursor-pointer"
                  onLoadStart={() => setImageLoaded(false)}
                  onLoadedData={() => setImageLoaded(true)}
                />
                {/* Left Arrow */}
                <div className="absolute left-4 top-1/2 transform -translate-y-1/2 z-10">
                  <img
                    src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759075131/Arrow_drop_left_xbnwv3.png"
                    alt="Previous"
                    className="w-[65px] h-[65px] cursor-pointer hover:opacity-80 transition-opacity"
                  />
                </div>
                {/* Right Arrow */}
                <div className="absolute right-4 top-1/2 transform -translate-y-1/2 z-10">
                  <img
                    src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759075131/Arrow_drop_left-1_gnp5sq.png"
                    alt="Next"
                    className="w-[65px] h-[65px] cursor-pointer hover:opacity-80 transition-opacity"
                  />
                </div>
              </>
            ) : (
              <>
                {!imageLoaded && (
                  <div className="absolute inset-0 bg-gray-300 animate-pulse flex items-center justify-center">
                    <div className="w-10 h-10 border-4 border-[#FDBD26] border-t-transparent rounded-full animate-spin"></div>
                  </div>
                )}
                <img
                  ref={imageRef}
                  src={publishedContent.image}
                  alt="Banner"
                  className={`w-full h-full object-contain cursor-pointer transition-opacity duration-300 ${
                    imageLoaded ? 'opacity-100' : 'opacity-0'
                  }`}
                  onLoad={handleImageLoad}
                  loading="eager"
                />
                {/* Left Arrow */}
                <div className="absolute left-2 md:left-4 top-1/2 transform -translate-y-1/2 z-10">
                  <img
                    src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759075131/Arrow_drop_left_xbnwv3.png"
                    alt="Previous"
                    className="md:w-[65px] w-[20px] h-[20px]  cursor-pointer hover:opacity-80 transition-opacity"
                  />
                </div>
                {/* Right Arrow */}
                <div className="absolute right-2 md:right-4 top-1/2 transform -translate-y-1/2 z-10">
                  <img
                    src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759075131/Arrow_drop_left-1_gnp5sq.png"
                    alt="Next"
                    className="md:w-[65px] w-[20px] h-[20px] md:h-[65px] cursor-pointer hover:opacity-80 transition-opacity"
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;